import { selector } from 'recoil';

import sessionStorage from './sessionStorage';

export const isAdminUserCheck = selector({
  key: 'IsAdminUser',
  get: ({ get }) => {
    const email = get(sessionStorage)?.user?.email;
    return email ? email.endsWith('@trunk.works') || email.endsWith('@artic.works') : false;
  },
});
